export const FILE_MAX_SIZE = 2097152

export const PASSWORD_MIN_LENGTH = 8

export const KEYWORDS_MIN_LENGTH = 1
